import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCl9_WbmxOKPe9nA0dtlhH_3zLjmDMplQU",
  authDomain: "canal-de-denuncias-3fb8e.firebaseapp.com",
  projectId: "canal-de-denuncias-3fb8e",
  storageBucket: "canal-de-denuncias-3fb8e.firebasestorage.app", // CORRIGIDO: Endereço correto do bucket
  messagingSenderId: "1009325818637",
  appId: "1:1009325818637:web:331b507ca6dedb15bc6644",
  measurementId: "G-G4XBGPE94W"
};

// Initialize Firebase
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'southamerica-east1');

export { auth, db, storage, functions };
